import React from 'react';
import TimeSelect from '../../../../components/TimeSelect/TimeSelect';
import { Select } from '../../../../flayr-components';

interface ITimeInputProps {
  timeConstraint?: string;
  time?: string;
  reason?: string;
  onChange?: (e: any) => void;
}

const TimeInput: React.FC<React.PropsWithChildren<React.PropsWithChildren<ITimeInputProps>>> = ({
  timeConstraint = '',
  time,
  reason,
  onChange,
}) => {
  const reasons = [
    {
      label: 'Selected wrong time',
      value: 'Selected wrong time',
      conditional: false,
    },
    {
      label: 'Not sure if the provider has given enough time',
      value: 'Not sure if the provider has given enough time',
      conditional: false,
    },
    {
      label: 'I need to be finished by this time',
      value: 'I need to be finished by this time',
      conditional: true,
    },
    {
      label: 'I can only start at this time',
      value: 'I can only start at this time',
      conditional: true,
    },
  ];
  return (
    <div className="">
      <TimeSelect
        label={`Select new ${timeConstraint} time`}
        size="lg"
        name="time"
        value={time}
        onChange={onChange}
      />

      <Select
        label="Reason for time change"
        size="lg"
        options={reasons.filter(
          (r) =>
            !r.conditional ||
            (r.conditional && r.value.includes?.(timeConstraint))
        )}
        name="reason"
        value={reason}
        onChange={onChange}
      />
    </div>
  );
};
export default TimeInput;
